/**
 * Utility Functions to submit apply form
 * No need to maintain any states or properties, just return the results
 */
import formurlencoded from 'form-urlencoded';
import root from 'window-or-global';

import FetchHelper from '../FetchHelper';
import ApplyCookieHelper from './ApplyCookieHelper.js';
import Apply from './index';
import { openApplyForm, clearDirectApplyAdId } from '../../actions/ApplyActions';
import store, { JobStore } from '../../store';
import { getParamFromUrl, getProtocol } from '../../utils/index';
import { firePageLoadGa } from '../../utils/GaHelper/index';
import WebStorageWrapper from '../WebStorageWrapper';
import { API_URL, CALL_RECRUITER_NUMBER_API, LOG_DATA_API_URL } from '../../constants';


export default class ApplyService {
	constructor() {
		this.applyCookieHelper = new ApplyCookieHelper();
		this.fetchHelper = new FetchHelper();
	}
 
	saveApplyFirstStep(inputFields, apply, user) {
		let formObject = '';
		try {
			formObject = this.getFirstStepRequest(inputFields, apply, user);
		}
		catch (error) {
			console.log(error);
		}

		let formData = formurlencoded(formObject);

		//console.log(formData);return;
		let updateduser = {
			mobile: formObject.var_mobile,
			email: formObject.var_email_Id,
			name: formObject.var_name,
			loggedIn: (
        ((user.hasOwnProperty('loggedIn') && user.loggedIn))
        ||
        ((inputFields.hasOwnProperty('loggedIn') && inputFields.loggedIn))
      )
		};
		let params = {
			url: root.location.protocol + '//www.quikr.com/jobs/apply/stepOne',
			includeCredentials: true,
			data: formData
		};
		let returnValues = {
			updatedUser: updateduser,
			applyPromise: this.fetchHelper.request('POST', params)
		};
		return returnValues;
	}

  getFirstStepRequest(inputFields, apply, user) {
    // start: set apply source if available
    let directApplyAdId = Apply.getApplyStore('refDirectApplyAdId');
    let applySource = apply.source ? apply.source : 'VAP';

    if(directApplyAdId == apply.job.id)
      applySource = Apply.getApplyStore('applySource');
    // end : set apply source if available

    // Using Old Api For Now
		let request = {
			validateNewStep1: 1,
			adid: apply.job.id,
			var_current_role: (apply.job.roleAnswerId)?apply.job.roleAnswerId:'',
			roleName: apply.job.role,
			source: applySource,
			jsStep1: 1,
			isNewApply: 1, //Handle this
			pwaApply: 1,
			isViewContact: (apply.isCallButtonClicked)?1:0,
			var_locality:apply.job.locality,
			utmSource: Apply.getApplyStore('utmSource'),
			utmMedium: Apply.getApplyStore('utmMedium'),
			utmCampaign: Apply.getApplyStore('utmCampaign')
		};

    if (inputFields.hasOwnProperty('addEmailToUser')) {
      request.addEmailToUser = inputFields.addEmailToUser;
      delete inputFields.addEmailToUser;
    }

    if (!inputFields.hasOwnProperty('city')) {
      request.var_city = apply.job.cityName;
    }

    if (user.vipEnabled) {
      request.isVipApplyAvailable = 1;
    }

		this.applyCookieHelper.setPrefillItem('city', apply.job.cityName);
		for (const key of Object.keys(inputFields)) {
			this.applyCookieHelper.setPrefillItem(key, inputFields[key]);

			let name = key;

			//TODO Handle Email
			if (key === 'email') {
				name = 'email_Id';
			}

			request['var_' + name] = inputFields[key];
		}

    request.isConflictCheckRequired = root.localStorage.getItem('isConflictCheckRequired');

		try {
			if (!request['var_locality'] || request['var_locality'] === ''){
				request['var_locality'] = 'Entire '+apply.job.cityName.replace('x:','');
				request['var_city_show'] = request['var_city'];
			}
		}
		catch (error) {

		}

		/*
		if (request['var_city'] && request['var_city'].indexOf('x:') > -1 ){
			let abroadCity = request['var_city'].replace('x:','');
			request['var_city'] = request['var_locality'];
			request['var_locality'] = 'Enitire '+abroadCity;
		}*/

    let localStorage = WebStorageWrapper.getLocalStorage();
    if (localStorage.hasKey('su')) {
      request['su'] = localStorage.getItem('su');
    }

		return request;
	}

	saveApplySecondStep(inputFields, apply, user) {
		let formObject = this.getSecondStepRequest(inputFields, apply, user);

		let form_data = Object.keys(formObject).map((key) => {
			if (formObject[key] instanceof Array) {
				return formObject[key].map((value, i) => encodeURIComponent(key) + '=' + encodeURIComponent(value)).join('&');
			}
			return encodeURIComponent(key) + '=' + encodeURIComponent(formObject[key]);
		}).join('&');

		let params = {
			url: root.location.protocol + '//www.quikr.com/jobs/apply/stepTwo',
			includeCredentials: true,
			data: form_data
		};
		return this.fetchHelper.request('POST', params);
	}

  getSecondStepRequest(inputFields, apply, user) {
    let request = {
      adid: apply.job.id,
      jsStep2: 1,
      validateNewStep2: 1,
      isPremium: 0,
      pwaApply: 1,
      role: apply.job.role,
      firstName: user.name,
      email: user.email,
      mobile: user.mobile
    };

    if (user.id)
      request.userId  = user.id

    for (const key of Object.keys(inputFields)) {
      if (key === 'hasNewAnswers') {
        request.hasNewAnswers = inputFields[key];
      } else {
        if (inputFields[key]) {//&& inputFields[key].value > 0
          let arrayLabel = (Array.isArray(inputFields[key])) ? '[]' : '';
          request['var_' + key.replace(/ /g, '_') + arrayLabel] = inputFields[key];
        }
      }
    }
    return request;
  }

	/**
   * Get Vip credist for user
   */
	getVipApplyDetailsFromApi(jobId) {
		let postData = 'pwaApply=1&adId=' + jobId;

		let params = {
			url: root.location.protocol + '//www.quikr.com/jobs/getVipApplyCredits',
			includeCredentials: true,
			data: postData
		};
		return this.fetchHelper.request('POST', params);
	}

	/**
   * Save quick apply
   */
	saveQuickApply(job) {
    // start : set apply source if available
    let directApplyAdId = Apply.getApplyStore('refDirectApplyAdId');
    let applySource = 'HEMS_VAP';

    if(directApplyAdId == job.id)
        applySource = 'HEMS_' + Apply.getApplyStore('applySource');
    // end : set apply source if available

		let formObject = {
			adId: job.id,
			role: job.role,
			applyCount: (sessionStorage.applyCount)?sessionStorage.applyCount:0,
			dontAskFlag: (sessionStorage.dflag)? sessionStorage.dflag:false,
			showResumePromotionFlag: false,
      jobAppliedCounter: parseInt(localStorage.jobAppliedCounter, 10) + 1,
      source: applySource,
      utmSource: Apply.getApplyStore('utmSource'),
			utmMedium: Apply.getApplyStore('utmMedium'),
			utmCampaign: Apply.getApplyStore('utmCampaign')
    };

		let formData = formurlencoded(formObject);

		let params = {
			url: root.location.protocol + '//www.quikr.com/jobs/quickApply',
			includeCredentials: true,
			data: formData
		};

		return this.fetchHelper.request('POST', params);
	}

	/**
	 * Update Already Applied Details
	 */
	submitUpdateApply(data, apply) {

		let changedQsObj = { locality: data.locality };
		let basicProfDataObj = {
			email: data.email,
			mobile: data.mobile,
			name: data.name,
			city: data.city
		};

		if (apply.firstStepProfile) {
			for (let key in basicProfDataObj) {
				if (basicProfDataObj[key] !== apply.firstStepProfile[key]){
					changedQsObj[key] = basicProfDataObj[key];
				}
			}
		}

		let formObject = {
			adId: apply.job.id,
			city: apply.job.city,
			role: apply.job.role,
			vipApply: 0,//TODO,
			source: 'MOBILE',
			changedQs: changedQsObj,
			basicProfData: basicProfDataObj,
			utmSource: Apply.getApplyStore('utmSource'),
			utmMedium: Apply.getApplyStore('utmMedium'),
			utmCampaign: Apply.getApplyStore('utmCampaign')
		};

		let formData = formurlencoded(formObject);

		//let formData = Object.keys(formObject).map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(formObject[key])).join('&');
		let params = {
			url: root.location.protocol + '//www.quikr.com/jobs/updateApplicationData',
			includeCredentials: true,
			data: formData
		};
		let response = this.fetchHelper.request('POST', params);
		response.then(apiResponse => {
      if (200 === apiResponse.status) {
        this.updateCookieAfterApply(data);
      }
    });
		return response;
	}

	getMobileVerifiedStatusPromise(mobile) {
		if (!mobile) return false;

		let formObject = {
			mobile
		};
		let formData = formurlencoded(formObject);
		let params = {
			url: root.location.protocol + '//www.quikr.com/jobs/jobsAjax/verificationStatus?'+formData
		};
		return this.fetchHelper.request('GET', params);
    }

    /**
     * Initialte apply for a job, incase the adId is present in url
     * feature introduced for amp
     */
    static directApplyAd = (source = null) => {
        let directApplyAdId = Apply.getApplyStore('directApplyAdId');
        let job = Apply.getJobFromStore(directApplyAdId);

        if (directApplyAdId && 'SNB' === source && !job) {
            // firing amp ga, if it is an amp apply but ad is not available
            firePageLoadGa('ampApplyError', { type: 'JobNotAvailable', adId: directApplyAdId });
        }

        let applyCookieHelper = new ApplyCookieHelper();
        let isJobApplied = applyCookieHelper.isJobApplied(directApplyAdId);
        // storeHasKey check is present to check if the context response is available
        if (job && !isJobApplied && JobStore.storeHasKey('apply','isQuickApplyEnabled')) {
            let source = getParamFromUrl('source');
            store.dispatch(openApplyForm(job));

            firePageLoadGa('applyinitiate', { type: 'inlineapply', source });
            if (root.history && root.location) {
                root.history.pushState(null, 'Apply for '+ job.title, root.location.pathname + root.location.search + '#apply');
            }
            // clear redux
            store.dispatch(clearDirectApplyAdId());
        } else if (isJobApplied) {
            store.dispatch(clearDirectApplyAdId());
            Apply.toggleJobListDisplay(true);

            if (directApplyAdId && 'SNB' === source) {
                // firing amp ga, if it is an amp apply but the ad was already applied
                firePageLoadGa('ampApplyError', { type: 'AlreadyApplied', adId: directApplyAdId });
            }
        }
    }

    updateCookieAfterApply = (data) => {
      for(let field in data) {
        if (data.hasOwnProperty(field)) {
          this.applyCookieHelper.setPrefillItem(field, data[field]);
        }
      }
    };

    callRecruiterNumberAjax = (payload) => {
      let params = {
        url: getProtocol() + API_URL + CALL_RECRUITER_NUMBER_API,
        data: formurlencoded(payload)
      };

      let fetchHelper = new FetchHelper();

      return fetchHelper.request('POST', params);
    };

    logExternalApplyDetails = payload => {
      let params = {
        url: getProtocol() + API_URL + LOG_DATA_API_URL,
        data: formurlencoded(payload)
      };

      let fetchHelper = new FetchHelper();
      return fetchHelper.request('POST', params);
    }
}

export const undoApplyService = (taskId, adId , city = 'all') => {
	let formObject ={
		taskId,adId,city
	};

	let formData = formurlencoded(formObject);

	let params = {
		url: root.location.protocol + '//www.quikr.com/jobs/undoExpressApply',
		includeCredentials: true,
		data: formData
	};
	let fetchHelper = new FetchHelper();

	return fetchHelper.request('POST', params);
};



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Apply/ApplyService.js